/** @jsx jsx */
import { graphql } from 'gatsby';
import ContentPage from './contentPage.jsx';

export default ContentPage;

/* Notes on this:
* This is run before the above (i.e. first) in the SSR
* This is NOT string interpolation. This is the Gatsby GraphQL tag function
*/
export const pageQuery = graphql`
  query($path: String!) {
    allBuilderModels {
      oneHarrysMarketingPage(
        target: { urlPath: $path }
        options: { cachebust: true }
      ) {
        content
      },
      oneHarrysTest (
        target: { urlPath: $path }
        options: { cachebust: true, includeRefs: true }
      ) {
        content
      },
    }
}
`;